import { render, staticRenderFns } from "./videoBox.vue?vue&type=template&id=9f840e3a&scoped=true&"
import script from "./videoBox.vue?vue&type=script&lang=js&"
export * from "./videoBox.vue?vue&type=script&lang=js&"
import style0 from "./videoBox.vue?vue&type=style&index=0&id=9f840e3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f840e3a",
  null
  
)

export default component.exports